module.exports = __webpack_public_path__ + "img/zhengshu7.bab3ef60.jpg";